import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SyncStatusService } from '../../service/sync-status.service';

@Component({
    selector: 'app-sync-status',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './sync-status.component.html',
    styleUrl: './sync-status.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SyncStatusComponent implements OnInit {
    readonly syncService = inject(SyncStatusService);
    readonly isExpanded = signal(false);

    ngOnInit(): void {
        this.syncService.init();
    }

    toggleExpanded(): void {
        this.isExpanded.update(v => !v);
    }

    formatSourceName(name?: string): string {
        if (!name) return 'Unknown';
        return name.split(/[-_]/).map(p => p.charAt(0).toUpperCase() + p.slice(1)).join(' ');
    }

    getInitial(name?: string): string {
        return name?.charAt(0)?.toUpperCase() || '?';
    }

    getElapsed(startedAt?: string): string {
        if (!startedAt) return '';
        const secs = Math.floor((Date.now() - new Date(startedAt).getTime()) / 1000);
        if (secs < 60) return `${secs}s`;
        const m = Math.floor(secs / 60);
        const s = secs % 60;
        return s > 0 ? `${m}m ${s}s` : `${m}m`;
    }

    formatCount(n: number): string {
        return n.toLocaleString();
    }
}
